import { gql } from '@apollo/client';

export const CREATE_REGION_MUTATOR = gql`
  mutation createRegionMutator(
    $master_list: Boolean
    $regions: [JSON]
    $group_id: String
    $company_id: String
    $user_email: String
    $return_batch: Boolean
  ) {
    createRegions(
      master_list: $master_list
      regions: $regions
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
      return_batch: $return_batch
    )
  }
`;

export const UPDATE_REGION_MUTATOR = gql`
  mutation updateRegionMutator(
    $master_list: Boolean
    $updated_region: JSON
    $original_region: JSON
    $group_id: String
    $company_id: String
    $user: String
  ) {
    updateRegion(
      master_list: $master_list
      updated_region: $updated_region
      original_region: $original_region
      group_id: $group_id
      company_id: $company_id
      user: $user
    )
  }
`;

export const DELETE_REGION_MUTATOR = gql`
  mutation deleteRegionMutator(
    $master_list: Boolean
    $region_id: String
    $region_name: String
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    deleteRegion(
      master_list: $master_list
      region_id: $region_id
      region_name: $region_name
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const ARCHIVE_REGION_MUTATOR = gql`
  mutation archiveRegionMutator(
    $group_id: String
    $company_id: String
    $region_id: String
    $user: String
  ) {
    archiveRegion(group_id: $group_id, company_id: $company_id, region_id: $region_id, user: $user)
  }
`;

export const UNARCHIVE_REGION_MUTATOR = gql`
  mutation unarchiveRegionMutator(
    $group_id: String
    $company_id: String
    $region_id: String
    $user: String
  ) {
    unarchiveRegion(
      group_id: $group_id
      company_id: $company_id
      region_id: $region_id
      user: $user
    )
  }
`;
